module.exports = __webpack_public_path__ + "img/lot_woodward_cars_filtered.538c9ff8.jpg";